import { createFromIconfontCN } from '@ant-design/icons'

const Icon = createFromIconfontCN({
  scriptUrl: '//at.alicdn.com/t/c/font_4013419_9hi40l6b909.js'
})

export { Icon as default }
